// extracted by mini-css-extract-plugin
export default {"sum":"Sum_sum__Dizsl"};